import React from 'react';
import Navbar from '@/components/layout/landing/Navbar';
import Footer from '@/components/layout/landing/Footer';
import RequestCourseForm from '@/components/landing/tutor/request-course-form';
import { Container } from 'reactstrap';
import PageBanner from '@/components/landing/common/PageBanner';
import SEO from '@/components/landing/seo';
import LandingLayout from '@/components/landing/home/LandingLayout';

const RequestCourse = () => {
  return (
    <>
      <SEO
        meta_title={'Course Request | Learnsic'}
        meta_description={'Request course'}
        meta_keywords={'request course, add course, learnsic course'}
        photo={''}
        canonical="request-course"
      />
      <LandingLayout>
        <PageBanner
          pageTitle=""
          breadcrumbTextOne="Home"
          breadcrumbTextTwo="Request Course"
          breadcrumbUrl="/"
          className="request-banner"
        />
        <Container>
          <div className="ptb-100">
            <RequestCourseForm />
          </div>
        </Container>
      </LandingLayout>
    </>
  );
};
export default RequestCourse;